module.exports = __webpack_public_path__ + "static/media/rg.0aa3e2ef.png";